import * as homeAPI from '@/api/home'

export function addArea(params) {
    homeAPI.toAddArea(params)
}

// 获取公告
export function hasNotice() {

    return new Promise(function(resolve, reject){
        homeAPI.getNotice()
            .then(function(result) {
                resolve(result.data)
            })
    })

}

// 获取 首页 焦点图
export function fetchFocusPictures() {

    const params = {
        client: 0
    }

    return new Promise(function(resolve, reject){
        homeAPI.getFocusPictures(params)
            .then(function(result) {

                let responseArray = new Array()

                for(let index in result.data.banner) {
                    responseArray.push(result.data.banner[index])
                }

                resolve(responseArray)
            })
    })

}

// 获取 首页 产品分类列表
export function fetchProductCategoryList() {

    let params = new Object()
    params.current_page = 1
    params.item_everypage = 100
    params.language = 'zh'


    return new Promise(function(resolve, reject){
        homeAPI.getProductCategoryList(params)
            .then(function(result) {

                let responseArray = new Array()

                for(let index in result.data.list) {
                    let item = new Object()

                    item.id = result.data.list[index].id
                    item.title = result.data.list[index].name
                    item.subTitle = result.data.list[index].ad
                    item.thumbnail = result.data.list[index].thumbnail

                    if(result.data.list[index].status == 0) {
                        responseArray.push(item)
                    }

                }
                resolve(responseArray)
            })
    })

}

// 获取 首页 新闻动态列表
export function fetchNews() {

    return new Promise(function(resolve, reject){
        homeAPI.getAllNews()
            .then(function(result) {

                let responseArray = new Array()

                for(let index in result.data.list) {

                    let item = new Object()

                    if(result.data.list[index].thumbnail != null) {
                        item.thumbnail = result.data.list[index].thumbnail
                    } else {
                        item.thumbnail = 'http://www.xinhuanet.com/politics/2018-04/13/1122680222_15236282852201n.jpg'
                    }

                    item.id = result.data.list[index].id
                    item.url = result.data.list[index].url
                    item.createtime = result.data.list[index].createtime
                    item.title = result.data.list[index].title.substring(0, 15) + '...'
                    item.summary = result.data.list[index].summary.substring(0, 50) + '...'

                    responseArray.push(item)

                }
                resolve(responseArray)
            })
    })

}